import { Mail, MapPin, Clock } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { InquiryForm } from "@/components/InquiryForm";
import { SocialLinks } from "@/components/SocialLinks";
import { useSettings } from "@/context/SettingsContext";

export default function ContactPage() {
  const { pages, settings } = useSettings();
  const email = settings?.notification_email || "Chris@underdogpodcasts.com";
  return (
    <div className="min-h-screen flex flex-col" data-testid="contact-page">
      <Navbar />
      <main className="flex-1 w-full max-w-[1400px] mx-auto px-5 sm:px-8 pt-10 pb-32">
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-10 items-start">
          <div>
            <p className="eyebrow mb-3">{pages.contact_eyebrow || "Say hello"}</p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-none" data-testid="contact-title">{pages.contact_title || "Contact us"}</h1>
            <p className="mt-6 text-slate-300 leading-relaxed max-w-xl" data-testid="contact-intro">{pages.contact_intro}</p>
            <div className="mt-8 space-y-3 text-sm">
              <a href={`mailto:${email}`} className="flex items-center gap-3 card-surface rounded-2xl px-4 py-3 hover:text-sky-300 transition-colors" data-testid="contact-email-link"><Mail size={16} className="text-sky-400" /> {email}</a>
              <div className="flex items-center gap-3 card-surface rounded-2xl px-4 py-3 text-slate-300"><Clock size={16} className="text-sky-400" /> We usually reply within two business days</div>
              <div className="flex items-center gap-3 card-surface rounded-2xl px-4 py-3 text-slate-300"><MapPin size={16} className="text-sky-400" /> Recording from studios and spare bedrooms everywhere</div>
            </div>
            <div className="mt-6"><SocialLinks settings={settings || {}} size={18} className="flex" /></div>
          </div>
          <InquiryForm kind="contact" title={pages.contact_form_title || "Send a message"} testId="contact"
            fields={[{ id: "subject", label: "Subject", required: true, full: true, placeholder: "What's this about?" }]}
            messagePlaceholder="Tell us what's on your mind…" successText="Your message is in our inbox — we'll reply by email soon." />
        </div>
      </main>
      <Footer />
    </div>
  );
}
